import { useQuery } from 'react-query';
import { chamarOktonBank } from '../oktonbank';

export interface ResumoMonitorBancario {
  saldoanterior: string;
  entradas: string;
  saidas: string;
  saldodisponivel: string;
}

export function useResumoMonitorBancario(
  conta: string,
  dataIni: string,
  dataFim: string,
  habilitado = true,
) {
  return useQuery(
    ['monitor-bancario-resumo', conta, dataIni, dataFim],
    () =>
      chamarOktonBank<ResumoMonitorBancario>('OBFinanceiro', 'resumoMonitor', {
        conta,
        dataini: dataIni,
        datafim: dataFim,
      }),
    { enabled: habilitado && !!conta && !!dataIni && !!dataFim },
  );
}
